export const getProductPriceExcludingVAT = (product, channelId) => {
  if (!product) {
    return null;
  }

  const vatRate = product.channelPrices?.[channelId]?.vatRate || null;
  const price = product.channelPrices?.[channelId]?.priceWithTaxes || null;

  if (!price) {
    return null;
  }

  if (!vatRate) {
    return price;
  }

  return price / (1 + vatRate / 100);
};

export default {
  getProductPriceExcludingVAT,
};
